import React, {Component} from 'react';
import {injectIntl} from '@meiko/react-intl';
import styled from 'styled-components';
import propTypes from 'prop-types';
import {buildingStateColors, buildingStateHighlightColors} from 'styles/constants';
import {state as buildingStates} from 'dicts/buildings';

const Marker = styled.span`
	display: inline-block;
	width: 11px;
	height: 11px;
	border-radius: 50%;
	${({state}) => `
		border: 1px solid ${buildingStateHighlightColors[state]};
		background-color: ${buildingStateColors[state]};
	`};
`;

class BuildingMarker extends Component {
	render() {
		const {intl, state} = this.props;
		return (
			<Marker title={intl.formatMessage({id: buildingStates[state]})} state={state} />
		);
	}
}

BuildingMarker.propTypes = {
	intl: propTypes.object,
	state: propTypes.string,
};

export default injectIntl(BuildingMarker);
